<template>
    <el-popover
            :placement="placement"
            width="200"
            trigger="hover"
    >
        <img style="margin-bottom: -3px;cursor:pointer;width: 16px;height: 16px;"
             slot="reference"
             src="../assets/images/mark.png"
             alt=""
        />
        <p v-for="(item, index) in text" :key="index" :style="{margin: 0, textIndent: '20px'}">{{item}}</p>
    </el-popover>
</template>

<script>
    export default {
        name: "tip",
        props: {
            text: Array,
            placement: String
        }
    }
</script>

<style scoped>

</style>